<template>
  <el-container>
    <el-main>
      <div
          style="width:100%; margin:5px; display: flex;flex-direction: column;flex-wrap: wrap;justify-content: center; align-items: center;">
        <div v-for="(device, index) in deviceList" :key="index">
          <div style="display: inline-block;">{{ device.deviceId }}</div>
          <el-button type="primary" @click="changeDeviceIp(index)" :loading="device.changeIpLoading">重置设备流量IP
          </el-button>
        </div>
      </div>
      <el-button type="primary" @click="changeIp" :loading="changeIpLoading">重置Gr WiFi的IP</el-button>
      <el-button type="primary" @click="bootPc(1)" :loading="changeIpLoading">旧电脑开机</el-button>
      <el-button type="primary" @click="bootPc(2)" :loading="changeIpLoading">新电脑开机</el-button>
    </el-main>
  </el-container>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "ResetIp",
  data() {
    return {
      activeIndex: 0,
      select: 1,
      urlInput: "",
      username: "",
      password: "",
      dialogVisible: false,
      useOutDialogVisible: false,
      buyVipDialogVisible: false,
      contactServiceDialogVisible: false,
      useTutorialDialogVisible: false,
      warningDialogVisible: false,
      warningDialogTitle: null,
      warningDialogContent: null,
      loginCodeUrl: null,
      payCodeUrl: null,
      expireTime: null,
      changeIpLoading: false,
      isIndex: true,
      deviceList: [],
    }
  },
  computed: {
    ...mapState("ui", ["showHeaderBar", "showBottomNav", "transBackground"]),
    ...mapState("user", ["token"]),
  },
  components: {},
  methods: {
    changeIp() {
      this.changeIpLoading = true;
      let that = this;
      this.$api
          .post("/homeip/reconnectPPPoE", {
            operatePwd: that.token
          })
          .then(response => {
            that.changeIpLoading = false;
          })
          .catch(error => {
            that.changeIpLoading = false;
          });
    },
    bootPc(pc) {
      let that = this;
      this.$api
          .post("/CwHelper/bootPc", {
            token: that.token,
            pc:pc,
          })
          .then(response => {
            that.$message({
              message: '开机成功',
              type: 'success',
              duration: 1000,
              showClose: true
            });
          })
          .catch(error => {
            that.$message({
              message: '开机失败',
              type: 'warning',
              duration: 1000,
              showClose: true
            });
          });
    },
    getDeviceList() {
      let that = this;
      this.$api
          .post("/CwHelper/admin/availableDeviceList", {
            token: that.token
          })
          .then(response => {
            console.log(response);
            that.deviceList.length = 0;
            if (response.data.resultCode === 0) {
              for (let i = 0; i < response.data.deviceList.length; i++) {
                that.deviceList.push({
                  deviceId: response.data.deviceList[i].deviceId,
                  online: response.data.deviceList[i].online,
                  changeIpLoading: false,
                });
              }
            }
          })
          .catch(error => {
            console.log(error);
            that.deviceList.length = 0;
          });
    },
    changeDeviceIp(index) {
      console.log('changeDeviceIp' + index);
      this.deviceList[index].changeIpLoading = true;
      let that = this;
      this.$api
          .post("/CwHelper/admin/operateDevice", {
            token: that.token,
            deviceId: that.deviceList[index].deviceId,
            operate: '10001'
          })
          .then(response => {
            that.deviceList[index].changeIpLoading = false;
          })
          .catch(error => {
            that.deviceList[index].changeIpLoading = false;
          });
    },
    showWarningDialog(title, content) {
      this.warningDialogTitle = title;
      this.warningDialogContent = content;
      this.warningDialogVisible = true;
    },
  },
  created() {
    //created
  },
  mounted() {
    let that = this;
    //查询用户信息
    //this.queryUserInfo();
    //获取配置信息
    //this.queryActivity();
    that.getDeviceList();
  },
  beforeDestroy() {
    // window.removeEventListener("resize", ()=> this.updateScreenSize(this.$refs.header.offsetWidth));
  },
};
</script>

<style>

.el-container {
  height: 100%;
}

.el-header {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #FFFFFF;
  box-shadow: 0px 2px 3px #dddddd;
  color: #333;
  z-index: 1001;
}

.el-footer {
  width: 100%;
  background-color: #eeeeee;
  color: #bbbbbb;
  font-size: 10px;
  text-align: center;
  line-height: 30px;
}

.el-footer a:visited {
  color: #bbbbbb;
  text-decoration: none;
}

.el-main {
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;
  color: #333;
  text-align: center;
  padding: 10px;
}

.el-input-group__append {
  background-color: #409EFF;
  color: #FFFFFF;
  border-radius: 0 20px 20px 0;
  border: #409EFF solid 1px;
}

.el-input__inner {
  border-radius: 20px;
  border: #bbbbbb solid 1px;
}

.input-with-select {
  line-height: 1;
}

.res-type {
  width: 100%;
  height: 30px;
  line-height: 30px;
  font-weight: 600;
  font-size: 15px;
  color: #FFFFFF;
  background: #409EFF;
}

.download-video {
  width: 150px;
  margin-top: 10px;
  display: block;
}

.checked-icon {
  color: #409EFF;
  font-size: 20px;
  position: absolute;
  padding: 2px;
  right: 0;
  top: 0;
}

.unchecked-icon {
  color: #AAAAAA;
  font-size: 20px;
  position: absolute;
  padding: 2px;
  right: 0;
  top: 0;
}

.hint-text {
  font-size: 10px;
  line-height: 15px;
  color: #888888;
  margin-top: 3px;
  text-align: left;
}

.img-item {
  width: 120px;
  height: 120px;
  margin: 5px;
  position: relative;
  box-shadow: 0 0 3px #333333;
}

.img-item a {
  display: none;
}

.img-item:hover a {
  display: inline;
}

.el-dialog__body {
  padding: 0;
}

.month-vip-title {
  margin-top: 50px;
  font-size: 16px;
  color: #000000;
  font-weight: 500;
}

.month-vip-items {
  width: 100%;
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.month-vip-item-choose {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 30px;
  border-color: #09BB07;
  border-style: solid;
  border-width: 2px;
  border-radius: 5px;
}

/*.img-item i {
    border:1px solid rgba(0,0,0,0);
}

.img-item:hover i {
    border:1px solid #409EFF;
}*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
</style>
